import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDishWash = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Ebene_1",
	xmlns: "http://www.w3.org/2000/svg",
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M13.67,10.423l0.226,2.035c-0.366,1.81-0.512,4.028-0.57,6.519c-0.865,0.599-1.912,0.951-3.041,0.951 c-2.954,0-5.357-2.403-5.357-5.357c0-2.954,2.403-5.357,5.357-5.357C11.569,9.214,12.747,9.668,13.67,10.423z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M13.286,23.142c0,0.12,0.016,0.234,0.035,0.349C12.367,23.815,11.349,24,10.286,24c-5.207,0-9.429-4.222-9.429-9.429 c0-5.207,4.222-9.428,9.429-9.428c1.111,0,2.172,0.202,3.162,0.554c-0.139,0.474-0.194,0.973-0.138,1.474l0.176,1.583 c-0.951-0.524-2.04-0.825-3.2-0.825c-3.663,0-6.643,2.98-6.643,6.643c0,3.663,2.979,6.643,6.643,6.643 c1.086,0,2.108-0.268,3.015-0.731C13.291,21.345,13.286,22.229,13.286,23.142z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M23.143,23.142c0,0.473-0.384,0.858-0.856,0.858h-6.857c-0.473,0-0.858-0.385-0.857-0.858 c0.002-3.995,0.042-7.907,0.626-10.621l-0.61-5.492c-0.163-1.464,0.983-2.744,2.456-2.744h3.629c1.473,0,2.618,1.28,2.456,2.744 l-0.61,5.492C23.101,15.234,23.141,19.147,23.143,23.142z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M20.571,3h-3.428V0.857C17.143,0.384,17.526,0,18,0h1.714c0.473,0,0.857,0.384,0.857,0.857V3z"
		})
	]
});
export default SvgDishWash;
